export default __webpack_public_path__ + "static/media/room-polen-4.e58614ac.webp";